import React from 'react';
import { Container } from '@pixi/react';
import Clock from '../clock';
import BalanceWrapper from '../../../containers/common/balanceWrapper';
import GameSettingsWrapper from '../../../containers/common/gameSettingsWrapper';

function BottomLeft() {
  return (
    <Container y={718} x={20} name='BottomLeft'>
      <Clock />
      <GameSettingsWrapper />
      <BalanceWrapper />
    </Container>
  );
}

export default BottomLeft;
